import React, { useState } from 'react';
import FadeCollapse from 'components/FadeCollapse/FadeCollapse';

import { POSDefaultsProps } from 'types';
import styles from './POSDefaults.module.scss';

interface ComponentProps {
  closeModal: () => void;
}

const POSDefaults: React.FC<POSDefaultsProps & ComponentProps> = ({ closeModal, menuItem }) => {
  const [openOptions, setOpenOptions] = useState<string[]>([]);

  const handleToggle = (posId: string): void => {
    const _openOptions = [...openOptions];
    const index = _openOptions.indexOf(posId);

    if (index === -1) {
      _openOptions.push(posId);
    } else {
      _openOptions.splice(index, 1);
    }

    setOpenOptions(_openOptions);
  };

  if (!menuItem) {
    return null;
  }

  return (
    <div className={styles.Outer} data-testid="pos-defaults">
      <button
        className={styles.CloseButton}
        aria-label="Close Modal"
        type="button"
        onClick={closeModal}
        tabIndex={0} // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      >
        <i className="mm-times" />
      </button>
      <h2>POS IDs</h2>
      <p data-testid="pos-defaults-copy">To make any changes to your POS defaults, please head to your POS.</p>
      <ul className={styles.List} data-testid="pos-defaults-list">
        <li>
          <strong>
            <div>POS ID {menuItem.posId}</div>
            <div>{menuItem.name}</div>
          </strong>
        </li>
        {menuItem.options.map(({ posId, name, variants }) => {
          const isOpen = openOptions.indexOf(posId) !== -1;

          return (
            <React.Fragment key={posId}>
              <li>
                <button type="button" className={isOpen ? styles.Open : ''} onClick={() => handleToggle(posId)}>
                  <div>POS ID {posId}</div>
                  <div>
                    {name}
                    <i className="mm-angle-down" />
                  </div>
                </button>
              </li>
              <FadeCollapse open={isOpen}>
                {variants.map(({ posId: variantPosId, name: variantName }) => {
                  return (
                    <li key={variantPosId}>
                      <span>
                        <div>POS ID {variantPosId}</div>
                        <div>{variantName}</div>
                      </span>
                    </li>
                  );
                })}
              </FadeCollapse>
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};

export default POSDefaults;
